
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import { useParams } from "react-router-dom";




const AppUserLoginSessions = () => {
    const { id } = useParams();

    const [appUser, setAppUser] = useState([]);
    const [appUserLoginSessions, setAppUserLoginSessions] = useState([]);

    const [query, setQuery] = useState("");
    useEffect(() => {
        axiosConfig.get("/appuser/login/sessions/"+ id).then((rsp) => {
            setAppUser(rsp.data.userData);
            setAppUserLoginSessions(rsp.data.user_login_sessions);
            //console.log(rsp.data);
        }, (err) => { });


    }, []);


    const Search = (data) => {
        return data.filter(
            (item) =>
                item.user_id && item.user_id.toString().includes(query)
        );
    };



    



    return (
        <div><Header title="App User Login Sessions" />
            <MainMenu menu="appusers" />
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">



                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">{ appUser.user_name} - Login Sessions</div></div>
                                                            <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search" onChange={e => setQuery(e.target.value)} />
                                                            </div>

                                                        </div>
                                                        {/* <a class="btn btn-primary" href="/device/create">Create New</a> */}
                                                        {/* <button class="btn btn-success pull-right" onClick={exportDevices}>Export</button> */}
                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            {
                                                                appUserLoginSessions.length > 0 ? 
                                                                    <table class="table display nowrap table-striped table-bordered">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Session ID</th>
                                                                            <th>Start</th>
                                                                            <th>End</th>
                                                                            <th>Session Duration(Min)</th>
                                                                            <th>Details</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {Search(appUserLoginSessions).map((session) =>
                                                                            <tr key={session.id}>
                                                                                <td class="text-warning">#{session.id}</td>
                                                                                <td>{session.start}</td>
                                                                                <td>{session.end !== null ? <span class="">{session.end}</span> : <span class="text-success">Active</span>}</td>
                                                                                <td>{session.duration !== null ? <span class="">{session.duration}</span> : 'Not Available'}</td>
                                                                                <td><a href={"/app/user/activity/log/"+session.id} class="btn btn-primary">View</a></td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                                : <div class="h3 font-weight-bold text-center">No Session Found</div>
                                                            }
                                                            
                  
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >





                            </div>
                        </div>


                        <br />



                        <br />


                    </div>
                </div>

            </div>
        </div>
    )

}
export default AppUserLoginSessions;